module.exports = __webpack_public_path__ + "static/img/footer_768.049df2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/footer_768.png
// module id = xtx0
// module chunks = 0